/*
 * Copyright (c) 2021 SARL SIGMA POLYNESIA
 */

import { FormattedMessage, useIntl } from 'react-intl'
import RequirePerm from '../../../../modules/auth/components/RequirePerm'
import { INVOICE_SALE } from '../../../../modules/twh/enums/InvoiceTypes.mjs'
import PageTitle from '../PageTitle'
import NavLinkItem from '../sidebar/NavLinkItem'
import { getCustomerListLink } from '../../../../modules/twh/lib/links/customerLinks'
import { getEstateListLink } from '../../../../modules/twh/lib/links/estateLinks'
import { getInterventionListLink } from '../../../../modules/twh/lib/links/interventionLinks'
import { getInvoiceListLink } from '../../../../modules/twh/lib/links/invoiceLinks'
import { getLeaseListLink } from '../../../../modules/twh/lib/links/leaseLinks'
import {
  getManagementReportListLink
} from '../../../../modules/twh/lib/links/managementReportLinks'
import { getMandateListLink } from '../../../../modules/twh/lib/links/mandateLinks'
import { getProspectingListLink } from '../../../../modules/twh/lib/links/prospectingLinks'
import { getTransactionListLink } from '../../../../modules/twh/lib/links/transactionLinks'
import { getAgendaLink } from '../../../../modules/twh/lib/links/agendaLinks'
import { Box, Card, Container, SimpleGrid, Title } from '@mantine/core'
import Page from '../Page'

function AdminPage () {
  const intl = useIntl()
  return (
    <Page>
      <Container size="md">
        <PageTitle
          hidden
          title={intl.formatMessage({
            id: 'welcome',
            defaultMessage: 'Bienvenue'
          })}
        />

        <SimpleGrid cols={{ md: 2 }}>
          <Card shadow="sm">
            <Title
              ta="center"
              tt="uppercase"
              order={2}
            >
              {intl.formatMessage({
                id: 'commercial',
                defaultMessage: 'Commercial'
              })}
            </Title>
            <Box>
              <RequirePerm
                permissions={['read:customer', 'write:customer']}
                render={() => (
                  <NavLinkItem
                    to={getCustomerListLink()}
                    label={<FormattedMessage
                      id="contacts"
                      defaultMessage="Contacts"
                    />}
                  />
                )}
              />
              <RequirePerm
                permissions={['read:mandate', 'write:mandate']}
                render={() => (
                  <NavLinkItem
                    to={getMandateListLink()}
                    label={<FormattedMessage
                      id="mandates"
                      defaultMessage="Mandats"
                    />}
                  />
                )}
              />
              <RequirePerm
                permissions={['read:estate', 'write:estate']}
                render={() => (
                  <NavLinkItem
                    to={getEstateListLink()}
                    label={<FormattedMessage
                      id="estates"
                      defaultMessage="Biens"
                    />}
                  />
                )}
              />
              <RequirePerm
                permissions={['read:prospecting', 'write:prospecting']}
                render={() => (
                  <NavLinkItem
                    to={getProspectingListLink({ succeeded: 'null' })}
                    label={<FormattedMessage
                      id="prospecting.plural"
                      defaultMessage="Prospections"
                    />}
                  />
                )}
              />
              <RequirePerm
                permissions={['read:invoice', 'write:invoice']}
                render={() => (
                  <NavLinkItem
                    to={getInvoiceListLink({ type: INVOICE_SALE })}
                    label={<FormattedMessage
                      id="sales"
                      defaultMessage="Ventes"
                    />}
                  />
                )}
              />
            </Box>
          </Card>

          <Card shadow="sm">
            <Title
              ta="center"
              tt="uppercase"
              order={2}
            >
              {intl.formatMessage({
                id: 'management',
                defaultMessage: 'Gestion'
              })}
            </Title>
            <Box>
              <RequirePerm
                permissions={['read:lease', 'write:lease']}
                render={() => (
                  <NavLinkItem
                    to={getLeaseListLink()}
                    label={<FormattedMessage
                      id="rental_files"
                      defaultMessage="Dossiers de location"
                    />}
                  />
                )}
              />
              <RequirePerm
                permissions={['read:invoice', 'write:invoice']}
                render={() => (
                  <NavLinkItem
                    to={getInvoiceListLink()}
                    label={<FormattedMessage
                      id="invoicing"
                      defaultMessage="Facturation"
                    />}
                  />
                )}
              />
              <RequirePerm
                permissions={['read:transaction', 'write:transaction']}
                render={() => (
                  <NavLinkItem
                    to={getTransactionListLink(true)}
                    label={<FormattedMessage
                      id="expenses"
                      defaultMessage="Dépenses"
                    />}
                  />
                )}
              />
              <RequirePerm
                permissions={['read:transaction', 'write:transaction']}
                render={() => (
                  <NavLinkItem
                    to={getTransactionListLink(false)}
                    label={<FormattedMessage
                      id="revenues"
                      defaultMessage="Revenus"
                    />}
                  />
                )}
              />
              <RequirePerm
                permissions={['read:management-report']}
                render={() => (
                  <NavLinkItem
                    to={getManagementReportListLink()}
                    label={<FormattedMessage
                      id="management_reports"
                      defaultMessage="Rapports de gérance"
                    />}
                  />
                )}
              />
              <RequirePerm
                permissions={['read:intervention', 'write:intervention']}
                render={() => (
                  <NavLinkItem
                    to={getInterventionListLink()}
                    label={<FormattedMessage
                      id="interventions"
                      defaultMessage="Interventions"
                    />}
                  />
                )}
              />
              <RequirePerm
                permissions={['read:calendar']}
                render={() => (
                  <NavLinkItem
                    to={getAgendaLink()}
                    label={<FormattedMessage
                      id="agenda"
                      defaultMessage="Agenda"
                    />}
                  />
                )}
              />
            </Box>
          </Card>
        </SimpleGrid>
      </Container>
    </Page>
  )
}

export default AdminPage
